import styled, {css} from 'styled-components';

import { layout } from '../../../../package.json';

export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

export const Title = styled.div`
  width: 100%;
  margin-bottom: 1rem;

  span {
    font-size: 1.5rem;

  }
`;

export const ContainerCreate = styled.div`
  display: flex;
  width: 100%;
  gap: 1rem;
  @media (max-width: ${layout.desktop}) {
    flex-direction: column;
  }
`;

export const ContainerCardCredit = styled.div`
  width: 100%;
  h1 {
    color: #000;
  }
  > div {
    width: 100%;
    max-width: 23.12rem;

    > div {
      > div {
        background: var(--primary);
      }
    }
  }
  
  @media (max-width: ${layout.desktop}) {
    > div {
      margin: 0 auto;
    }
  }
`;

export const ContainerFormCardCredit = styled.div`
  width: 100%;
`;

interface FormCardCreditBoxProps {
  justifyContent?: string;
  bDirectionColumn?: boolean;
}

export const FormCardCreditBox = styled.div<FormCardCreditBoxProps>`
  width: 100%;
  display:flex;
  ${props => props.justifyContent && `
  justify-content: ${props.justifyContent} ;
  margin-bottom: 30px;
  `}

  & + div {
    margin-top: 1rem;
    > div + div {
      margin-left: 1rem;
    }
  }

  button + div {
    margin-left: 1rem;
  }

  @media (max-width: ${layout.tablet}) {
    ${props => props.bDirectionColumn && css`
      flex-direction: column;
      div + div {
        margin-top: 1rem;
      }
    `}
    & + div {
      > div + div {
        margin-left: 0;
      }
    }
  }
  
`;

export const FormCardCreditBoxBTNCanc = styled.button`
  height: 56px;
  border: 0;
  border-radius: 10px;
  width: 162px;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: var(--btn-canc);
  cursor: pointer;
  span {
    color: var(--white);
    font-weight: 700;
    font-size: 19px;
  }
`;

export const FormCardCreditBoxBTN = styled.div`
  width: 162px;
`
